// Production build guard for the Firebase web config (release 0.1.0). The values are public, not secrets, but a
// build without them signs nobody in. vite.config.ts calls this for `vite build` in production mode.

/** The Firebase web config vars that a production build must set. */
export const FIREBASE_ENV_KEYS = [
  "VITE_FIREBASE_API_KEY",
  "VITE_FIREBASE_PROJECT_ID",
  "VITE_FIREBASE_AUTH_DOMAIN",
] as const;

/** Default project id in config.ts when VITE_FIREBASE_PROJECT_ID is not set. */
export const PLACEHOLDER_PROJECT_ID = "prego-console-placeholder";

/** Values from config.ts and .env.example that are not real config. */
const PLACEHOLDERS = new Set([
  PLACEHOLDER_PROJECT_ID,
  "demo-prego",
  "demo-api-key",
  "demo-prego.firebaseapp.com",
]);

/** Returns one message per missing or placeholder value. An empty list means the config is usable. */
export function firebaseEnvProblems(env: Record<string, string | undefined>): string[] {
  const problems: string[] = [];
  for (const key of FIREBASE_ENV_KEYS) {
    const value = (env[key] ?? "").trim();
    if (!value) problems.push(`${key} is not set`);
    // Firebase "demo-" projects exist only in the emulator.
    else if (PLACEHOLDERS.has(value) || value.startsWith("demo-")) {
      problems.push(`${key} is a placeholder value`);
    }
  }
  return problems;
}
